<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <app-tabela
            :itens="requisicaoItens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <btn-inserir-itens
                        :requisicao="requisicao"
                        @inserirItens="inserirItens($event)"
                        v-if="permiteInserirItens"
                    ></btn-inserir-itens>
                </b-button-group>
            </template>
            <template slot="descricao" slot-scope="data">
                {{ data.descricao }} ({{ data.idItemContrato }})
            </template>
            <template slot="valorUnitario" slot-scope="data">{{
                data.valorUnitario | currency
            }}</template>
            <template slot="quantidade" slot-scope="data">{{
                data.quantidade | currency2
            }}</template>
            <template slot="subTotal" slot-scope="data">{{
                data.subTotal | currency
            }}</template>
            <template slot="desconto" slot-scope="data"
                >{{ data.desconto | currency
                }}<btn-justificativa-desconto
                    :itemRequisicao="data"
                ></btn-justificativa-desconto
            ></template>
            <template slot="valorTotal" slot-scope="data">{{
                data.valorTotal | currency
            }}</template>
            <template slot="acoes" slot-scope="data">
                <btn-excluir-item-requisicao
                    :itemRequisicao="data"
                    v-if="permiteExcluirItens && data.permiteExcluir"
                    @excluirItem="excluirItem($event)"
                ></btn-excluir-item-requisicao>
                <btn-atualizar-item-requisicao
                    :itemRequisicao="data"
                    v-if="permiteAtualizarItens"
                    @atualizarItem="atualizarItem($event)"
                ></btn-atualizar-item-requisicao>
                <btn-desconto-item-requisicao
                    :itemRequisicao="data"
                    v-if="permiteAtualizarDescontoItens"
                    @atualizarDescontoItem="atualizarDescontoItem($event)"
                ></btn-desconto-item-requisicao>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BtnInserirItens from './BtnInserirItensRequisicao'
import RequisicoesServicos from './RequisicoesServicos'
import BtnExcluirItemRequisicao from './BtnExcluirItemRequisicao'
import BtnAtualizarItemRequisicao from './BtnAtualizarItemRequisicao'
import BtnDescontoItemRequisicao from './BtnDescontoItemRequisicao'
import BtnJustificativaDesconto from './BtnJustificativaDesconto'

export default {
    props: {
        requisicao: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        },

        permiteInserirItens: {
            type: Boolean,
            default: () => false
        },

        permiteExcluirItens: {
            type: Boolean,
            default: () => false
        },

        permiteAtualizarItens: {
            type: Boolean,
            default: () => false
        },

        permiteAtualizarDescontoItens: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            requisicaoItens: [],
            erros: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    filterable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'subTotal',
                    label: 'SubTotal',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'desconto',
                    label: 'Desconto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        inserirItens(itens) {
            this.$store.dispatch('addRequest')
            let itensRequisicaoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                itens: itens
            }
            RequisicoesServicos.inserirItensRequisicao(itensRequisicaoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Itens inseridos com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarItem(item) {
            this.$store.dispatch('addRequest')
            let itemRequisicaoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idItemRequisicao: item.idItemRequisicao,
                valorUnitario: item.valorUnitario,
                quantidade: item.quantidade
            }
            RequisicoesServicos.atualizarItemRequisicao(itemRequisicaoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Item atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        excluirItem(idItemRequisicao) {
            this.$store.dispatch('addRequest')
            let itensRequisicaoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idItemRequisicao: idItemRequisicao
            }
            RequisicoesServicos.excluirItemRequisicao(itensRequisicaoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Item excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterRequisicaoAtualizada')
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                            this.$emit('obterRequisicaoAtualizada')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarDescontoItem(item) {
            this.$store.dispatch('addRequest')
            let itemRequisicaoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                idItemRequisicao: item.idItemRequisicao,
                desconto: item.desconto,
                justificativa: item.justificativa,
                cancelarDesconto: item.cancelarDesconto
            }
            RequisicoesServicos.atualizarDescontoItemRequisicao(
                itemRequisicaoDto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Item atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.erros = response.errors
                        this.$emit('obterRequisicaoAtualizada')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    mounted() {
        this.requisicaoItens = [...this.requisicao.itens]
    },

    computed: {},

    watch: {
        requisicao() {
            this.requisicaoItens = [...this.requisicao.itens]
        }
    },

    components: {
        BtnInserirItens,
        BtnExcluirItemRequisicao,
        BtnAtualizarItemRequisicao,
        BtnDescontoItemRequisicao,
        BtnJustificativaDesconto
    }
}
</script>
